import './back-button.scss'
import { Icon } from '@vista-digital/occ-ui'
import type { FC } from 'react'
import { useLocation, useNavigate } from 'react-router-dom-v7'
import type { SubPageKeys } from '@/common/enums/pages.enum'
import { getSearchParameterByName } from '@/common/utils/getSearchParameterByName'
import { mobileEmbedService } from '@/content/services/mobileEmbed/mobileEmbed.service'
import { useUrlService } from '@/content/services/omnia-service-context'
import { foodAndBeverageWorkflow } from '@/content/services/workflows/foodAndBeverage/food-and-beverage-workflow'
import { ticketingWorkflow } from '@/content/services/workflows/ticketing/ticketing-workflow'
import { handleSeatPickerPageNavigation } from './utils/handleSeatPickerPageNavigation'

export interface BackButtonProps {
    buttonLabel: string
    currentSubPage?: SubPageKeys
}

const paymentPages: SubPageKeys[] = ['FoodAndBeverageOrderPayment', 'OrderPayment', 'GiftStorePayment']

export const BackButton: FC<BackButtonProps> = props => {
    const { buttonLabel, currentSubPage } = props
    const navigate = useNavigate()
    const location = useLocation()
    const isMobileApp = mobileEmbedService.isMobileApp()
    const urlService = useUrlService()

    const handleGoBackClick = () => {
        if (
            isMobileApp &&
            (currentSubPage === 'SeatPicker' ||
                currentSubPage === 'GiftStoreOrderComplete' ||
                location.key === 'default')
        ) {
            mobileEmbedService.close()
            return
        }

        // When a payment was cancelled we have the token parameter in the url
        // We want to go back 3 pages to skip the payment portal
        const tokenValue = getSearchParameterByName('token')
        if (tokenValue && paymentPages.includes(currentSubPage as SubPageKeys)) {
            void navigate(-3)
            return
        }

        if (currentSubPage === 'FoodAndBeverageOrderPayment') {
            foodAndBeverageWorkflow.goBackToPage('FoodAndBeverageOrderSummary')
        } else if (currentSubPage === 'OrderPayment') {
            ticketingWorkflow.goBackToPage('OrderSummary')
        }
        // If the current page is SeatPicker, we need to handle the navigation differently
        else if (!handleSeatPickerPageNavigation(currentSubPage, navigate, urlService, location)) {
            // Default behavior: go back one page in history
            void navigate(-1)
        }
    }

    return (
        <>
            <div className="go-back__wrapper">
                <div className="go-back" onClick={handleGoBackClick} role="button">
                    {isMobileApp && <Icon name="arrow-left" className="go-back__arrow" />}
                    {!isMobileApp && (
                        <>
                            <span className="go-back__arrow-container">
                                <Icon name="arrowLeft" className="go-back__arrow" />
                            </span>
                            <span className="go-back__label">{buttonLabel}</span>
                        </>
                    )}
                </div>
            </div>
        </>
    )
}
